import { ChangeDetectionStrategy, Component, viewChild } from "@angular/core";

import { DialogService } from "@bitwarden/components";

import { SharedModule } from "../../../shared";

import { ChangeEmailComponent } from "./change-email.component";

@Component({
  templateUrl: "edit-email-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SharedModule, ChangeEmailComponent],
})
export class EditEmailDialogComponent {
  private readonly changeEmailRef = viewChild.required(ChangeEmailComponent);

  submitLabel(): string {
    const changeEmail = this.changeEmailRef();
    return changeEmail.formGroup.controls.emailOwnershipVerification.enabled
      ? "changeEmail"
      : "continue";
  }

  clearEmail(): void {
    const changeEmail = this.changeEmailRef();
    if (changeEmail.formGroup.controls.emailOwnershipVerification.enabled) {
      changeEmail.formGroup.controls.emailOwnershipVerification.setValue("");
    } else {
      changeEmail.formGroup.controls.userVerificationAndNewEmail.controls.newEmail.setValue("");
    }
  }

  submitEmail(): void {
    void this.changeEmailRef().submit();
  }

  static open(dialogService: DialogService) {
    return dialogService.open(EditEmailDialogComponent);
  }
}
